import type { LOSType } from "@/models/opal";
import useAddressHelpers from "@/use/addressHelpers";
import useFormatter from "@/use/formatter";

export default function useAddressFormActions() {
  const { removePrefix } = useAddressHelpers();
  const { formatZipCode } = useFormatter();

  function formatAddress2(
    addressUnitTypeId: number | null,
    address2: string | null,
    addressUnitTypes: LOSType[],
  ) {
    const selectedUnitTypeId = addressUnitTypeId ? Number(addressUnitTypeId) : null;

    const selectedUnitType = selectedUnitTypeId
      ? addressUnitTypes?.find((a: LOSType) => a.id === selectedUnitTypeId)
      : null;

    const prefixes = [] as string[];

    addressUnitTypes.forEach((au: any) => {
      prefixes.push(au?.abbreviation);
      prefixes.push(au?.name);
    });

    return selectedUnitTypeId
      ? `${selectedUnitType?.abbreviation} ${removePrefix(address2?.trim(), prefixes)}`
      : null;
  }

  function getSelectedUnitType(addressUnitTypeId: number | null, addressUnitTypes: LOSType[]) {
    const selectedUnitTypeId = addressUnitTypeId ? Number(addressUnitTypeId) : null;

    return selectedUnitTypeId
      ? addressUnitTypes?.find((a: LOSType) => a.id === selectedUnitTypeId)
      : null;
  }

  function getSelectedUnitTypeName(addressUnitTypeId: number | null, addressUnitTypes: LOSType[]) {
    return getSelectedUnitType(addressUnitTypeId, addressUnitTypes)?.name || null;
  }

  return {
    formatAddress2,
    formatZipCode,
    getSelectedUnitType,
    getSelectedUnitTypeName,
    removePrefix,
  };
}
